import ThreadSidebar from "./ThreadSidebar";
import ChatHeader from "./ChatHeader";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";
import { useSendChatMessageMutation } from "../../../store/apiSlices/procurementAI";

export default function ProcurementChat() {
  return (
    <div className="border border-[#F3F3F5] rounded-[10px] flex h-[500px]">
      {/* THREAD LIST */}
      <ThreadSidebar />

      {/* CHAT WINDOW */}
      <ChatWindow />
    </div>
  );
}

function ChatWindow() {
  const [sendChatMessage, { isLoading }] = useSendChatMessageMutation();

  return (
    <div className="min-w-0 flex flex-col flex-1">
      <ChatHeader />

      <ChatMessages isLoading={isLoading} />

      <ChatInput sendChatMessage={sendChatMessage} isLoading={isLoading} />
    </div>
  );
}
